import React from 'react';
import WorkClock from '../../components/WorkClock/WorkClock';
import { isAdminUser } from '../../utils/roles';
import AdminTimeTracking from './AdminTimeTracking';
import './TimeTracking.scss';

function TimeTracking() {
  if (isAdminUser()) {
    return <AdminTimeTracking />;
  }

  return (
    <div className="dashboard time-tracking-page time-tracking-page--user">
      <div className="card card-table-wrap">
        <div className="card-body">
          <WorkClock logLimit={50} variant="page" />
        </div>
      </div>
    </div>
  );
}

export default TimeTracking;
